<template>
  <dr-wrapper 
    v-if="isInEditorMode" 
    v-bind="$props" 
    v-on="wrapOn" 
    :class="evaluateClasses(classes)">
    <v-container fluid class="pa-0">
      <v-card>
        <v-card-text class="text-center">
          <p class="display-2">HTML</p>
        </v-card-text>
      </v-card>
    </v-container>
  </dr-wrapper>
  <v-container
    fluid
    v-else-if="!isInEditorMode && isVisible" 
    class="pa-0" 
    v-html="html" 
    :class="evaluateClasses(classes)"></v-container>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  computed: {
    html() {
      return this.getDataSourceField(this.model.Html) || {}
    }
  }
}
</script>

<style></style>
